import { guardAdminOnly } from "@/lib/auth/routeGuards"
import { ClassroomManagement } from '@/components/adminPage/classroom/ClassroomManagement'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/classroom')({
  beforeLoad: guardAdminOnly,
  component: ClassroomComponent,
})

function ClassroomComponent() {
  return <ClassroomManagement />
}
